module.exports = __webpack_public_path__ + "img/audit2.f14148ab.png";